import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { useCanSeeTmBackedComplianceScreen } from "./-components/is-compliance-enabled";

/** Legacy filter route — redirects into the collapsed merchant filter set. */
export const Route = createFileRoute(
  "/(app)/_main-layout/_compliance/compliance/open",
)({
  component: ComplianceOpenRedirect,
});

function ComplianceOpenRedirect() {
  const tmBackedCompliance = useCanSeeTmBackedComplianceScreen();
  const navigate = useNavigate();
  useEffect(() => {
    void navigate({
      to: tmBackedCompliance ? "/compliance" : "/compliance",
      replace: true,
    });
  }, [navigate, tmBackedCompliance]);
  return null;
}
